import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { Inbox } from "../v1/Inbox";
import {
  MrfiktivCreateInboxDtoGen,
  MrfiktivInboxControllerGetParamsGen,
  MrfiktivInboxViewModelGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateInboxDtoGen
} from "../v1/data-contracts";

/**
 * Communicate with inbox API
 */
class InboxService {
  mrfiktivProxy: Inbox;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new Inbox(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create an inbox
   */
  async create(partnerId: string, data: MrfiktivCreateInboxDtoGen): Promise<MrfiktivInboxViewModelGen> {
    return (await this.mrfiktivProxy.inboxControllerCreate(partnerId, data)).data;
  }

  /**
   * Get all inboxes (paginated)
   */
  async get(
    data: MrfiktivInboxControllerGetParamsGen
  ): Promise<MrfiktivPageViewModelGen & { data?: MrfiktivInboxViewModelGen[] }> {
    return (await this.mrfiktivProxy.inboxControllerGet(data)).data;
  }

  /**
   * Get a single inbox
   */
  async getOne(partnerId: string, inboxId: string): Promise<MrfiktivInboxViewModelGen> {
    return (await this.mrfiktivProxy.inboxControllerGetOne(partnerId, inboxId)).data;
  }

  /**
   * Update an inbox
   */
  async update(
    partnerId: string,
    inboxId: string,
    data: MrfiktivUpdateInboxDtoGen
  ): Promise<MrfiktivInboxViewModelGen> {
    return (await this.mrfiktivProxy.inboxControllerUpdate(partnerId, inboxId, data)).data;
  }

  /**
   * Delete an inbox
   */
  async delete(partnerId: string, inboxId: string): Promise<MrfiktivInboxViewModelGen> {
    return (await this.mrfiktivProxy.inboxControllerRemove(partnerId, inboxId)).data;
  }
}

/**
 * Communicate with inbox API
 */
export default new InboxService(new MrfiktivHttpClientProvider());
